import { loadable } from "../../../components/loadable";
import TransactionModalLoadableFallback from './TransactionModalLoadableFallback';

export default loadable(() => import(/* webpackChunkName: "TransactionsModal" */ `./TransactionsModal`), TransactionModalLoadableFallback);
